/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byline_Written_ByInputs */

const en_byline_written_by = /** @type {(inputs: Byline_Written_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Written and maintained by`)
};

const ko_byline_written_by = /** @type {(inputs: Byline_Written_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`작성 및 운영`)
};

const ja_byline_written_by = /** @type {(inputs: Byline_Written_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`執筆および運営`)
};

/**
* | output |
* | --- |
* | "Written and maintained by" |
*
* @param {Byline_Written_ByInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const byline_written_by = /** @type {((inputs?: Byline_Written_ByInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byline_Written_ByInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_byline_written_by(inputs)
	if (locale === "ko") return ko_byline_written_by(inputs)
	return ja_byline_written_by(inputs)
});